import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo, useState } from 'react';
import { MobileAccordionPrimary } from '@sbercloud/uikit-product-mobile-accordion';
import { Divider } from '@snack-uikit/divider';
import { Switch } from '@snack-uikit/toggles';
import { ProductContext, useProductContext } from '../../../contexts';
import { getValue, setValue } from '../../../utils';
import { Control } from '../Control';
import { ObjectDecorator } from '../ObjectDecorator';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ToggleObjectControlUi(_ref) {
  var _ref2, _relatedUiProps$visib;
  var decoratorProps = _ref.decoratorProps,
    control = _ref.control,
    switchKey = _ref.switchKey,
    relateFn = _ref.relateFn,
    watchedValues = _ref.watchedValues,
    uiProps = _ref.uiProps;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useProductContext = useProductContext(),
    valueProp = _useProductContext.value,
    onChangeProp = _useProductContext.onChange;
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var value = getValue(valueProp, switchKey);
  var onChange = function onChange(newValue) {
    setValue(valueProp, switchKey, newValue);
    onChangeProp(_objectSpread({}, valueProp));
  };
  var AdaptiveAccordionPrimary = MobileAccordionPrimary;
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(AdaptiveAccordionPrimary, {
      selectionMode: "single",
      expanded: expanded,
      onExpandedChange: setExpanded,
      children: /*#__PURE__*/_jsx(AdaptiveAccordionPrimary.CollapseBlock, {
        outline: true,
        id: "key",
        header: /*#__PURE__*/_jsx(ObjectDecorator, _objectSpread(_objectSpread({}, decoratorProps), relatedDecoratorProps)),
        actions: /*#__PURE__*/_jsx(Switch, {
          showIcon: false,
          checked: value,
          onChange: function (_onChange) {
            function onChange(_x) {
              return _onChange.apply(this, arguments);
            }
            onChange.toString = function () {
              return _onChange.toString();
            };
            return onChange;
          }(function (checked) {
            onChange(checked);
            checked && setExpanded('key');
          })
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ProductContext.Provider, {
            value: {
              value: valueProp,
              onChange: function onChange(newValue) {
                setValue(newValue, switchKey, true);
                onChangeProp(_objectSpread({}, newValue));
              }
            },
            children: /*#__PURE__*/_jsx(Control, {
              formControl: _objectSpread(_objectSpread({}, control), {}, {
                accessorKey: ''
              })
            })
          })]
        })
      })
    })
  });
}